import { Link as MLink, LinkProps } from '@mui/material'

export const Link: React.FC<LinkProps> = (props) => {
  return <MLink {...props} />
}
